'use es6';

import { CODEMIRROR_SESSION_FETCH, CODEMIRROR_SESSION_SAVE, CODEMIRROR_SESSION_DELETE, CODEMIRROR_SESSION_EDITOR_UPDATE, CODEMIRROR_SESSION_EDITOR_REMOVE } from 'DesignData/actions/ActionTypes';
import { CACHE_MAX_ITEMS } from 'DesignData/constants/LocalStorage';
import * as client from 'DesignData/api/codemirror/Session';
import { getPortalId, getUserId } from 'DesignData/selectors/auth';
import { getCodemirrorEditorsSorted } from 'DesignData/selectors/codemirror';
import { createAsyncActions } from 'DesignData/lib/actions';
const getAsyncActions = createAsyncActions.bind(null, 'session');
/**
 * Fetch session data.
 */

export function fetch() {
  const {
    request,
    receive,
    error
  } = fetch;
  return (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    dispatch(request());
    return client.fetch(userId, portalId).then(session => dispatch(receive(session))).catch(err => dispatch(error(err)));
  };
}
Object.assign(fetch, getAsyncActions(CODEMIRROR_SESSION_FETCH));
/**
 * Save session data.
 */

export function save() {
  const {
    request,
    receive,
    error
  } = save;
  return (dispatch, getState) => {
    const state = getState();
    const {
      codemirrorSession
    } = state;
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    dispatch(request());
    return client.save(userId, portalId, codemirrorSession).then(session => dispatch(receive(session))).catch(err => dispatch(error(err)));
  };
}
Object.assign(save, getAsyncActions(CODEMIRROR_SESSION_SAVE));
/**
 * Deletes session data.
 */

export function del() {
  const {
    request,
    receive,
    error
  } = del;
  return (dispatch, getState) => {
    const state = getState();
    const userId = getUserId(state);
    const portalId = getPortalId(state);
    dispatch(request());
    return client.del(userId, portalId).then(() => dispatch(receive(null))).catch(err => dispatch(error(err)));
  };
}
Object.assign(del, getAsyncActions(CODEMIRROR_SESSION_DELETE));
/**
 * Removes session data for individual CodeMirror editors.
 *
 * @param  {(String|Number)|Array.<(String|Number)>}  ids   Session identifier(s) unique to the CodeMirror instance.
 */

export function removeEditorSession(ids) {
  return {
    type: CODEMIRROR_SESSION_EDITOR_REMOVE,
    ids: Array.isArray(ids) ? ids : [ids]
  };
}
/**
 * Adds session data for an individual CodeMirror editor.
 *
 * @param  {(String|Number)}  id      Session identifier unique to the CodeMirror instance.
 * @param  {Object}           session Session data specific to the CodeMirror instance.
 */

export function updateEditorSession(id, session) {
  return (dispatch, getState) => {
    dispatch({
      type: CODEMIRROR_SESSION_EDITOR_UPDATE,
      id,
      session
    });
    const state = getState();
    const sortedEditors = getCodemirrorEditorsSorted(state);

    if (sortedEditors.length > CACHE_MAX_ITEMS) {
      const removeIds = sortedEditors.slice(CACHE_MAX_ITEMS);
      dispatch(removeEditorSession(removeIds));
    }
  };
}